/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type StoreHistoryManagementListOrderRequest = {
    perPage?: number | null;
    page?: number | null;
    keyword?: string | null;
    sort?: string | null;
    direction?: StoreHistoryManagementListOrderRequest.direction | null;
    status?: Array<string>;
    code?: string | null;
    name?: string | null;
    startDate?: string | null;
    endDate?: string | null;
};

export namespace StoreHistoryManagementListOrderRequest {

    export enum direction {
        ASC = 'asc',
        DESC = 'desc',
    }


}

